import Vue from 'vue'

export default [
    /**
     * Páginas não autenticadas
     */
    {
        /**
         * Tela de Login
         */
        path: '/sistema',
        component: require('./pages/unauthenticated/sistema/login/login.vue').default,
        meta: {
            forVisitors: true,
            forAuth: false,
        }
    },
    {
        /**
         * Tela de esqueci minha senha
         */
        path: '/esqueci-minha-senha',
        component: require('./pages/unauthenticated/sistema/forgot-password/forgot-password.vue').default,
        meta: {
            forVisitors: true,
            forAuth: false,
        }
    },
    {
        path: '/',
        component: require('./layouts/auth/auth.vue').default,
        children: [
            {
                /**
                 * Tela de Início
                 */
                path: '/',
                component: require('./pages/unauthenticated/index/index.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Resultado da Busca
                 */
                path: '/busca/:id',
                component: require('./pages/unauthenticated/busca/resultado-busca').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Lista de Notícias
                 */
                path: '/noticias/noticias-ugt',
                component: require('./pages/unauthenticated/noticias/ugt-noticias/list-noticias.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela da Noticia
                 */
                path: '/noticias/noticia/:id',
                component: require('./pages/unauthenticated/noticias/ugt-noticias/noticias.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                },
            },
            {
                /**
                 * Tela de lista Palavra do Presidente
                 */
                path: '/noticias/palavra-do-presidente',
                component: require('./pages/unauthenticated/noticias/palavra-do-presidente/palavra-presidente').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Palavra do Presidente
                 */
                path: '/noticias/text-presidente/:id',
                component: require('./pages/unauthenticated/noticias/palavra-do-presidente/text-presidente').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de lista Comentários do Diretor
                 */
                path: '/noticias/comentario-do-diretor',
                component: require('./pages/unauthenticated/noticias/comentario-do-diretor/comentario-diretor').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Comentário do Diretor
                 */
                path: '/noticias/text-diretor/:id',
                component: require('./pages/unauthenticated/noticias/comentario-do-diretor/text-diretor').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Carta de Tupã
                 */
                path: '/institucional/carta-de-tupa',
                component: require('./pages/unauthenticated/institucional/carta-de-tupa/carta-de-tupa.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Diretoria
                 */
                path: '/institucional/diretoria',
                component: require('./pages/unauthenticated/institucional/diretoria/diretoria.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de História
                 */
                path: '/institucional/historia',
                component: require('./pages/unauthenticated/institucional/historia/historia.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Valores
                 */
                path: '/institucional/valores',
                component: require('./pages/unauthenticated/institucional/valores/valores.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Presidente
                 */
                path: '/institucional/presidente',
                component: require('./pages/unauthenticated/institucional/presidente/presidente.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de Publicações
                 */
                path: '/publicacoes',
                component: require('./pages/unauthenticated/publicacoes/publicacoes.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
            {
                /**
                 * Tela de contato
                 */
                path: '/contato',
                component: require('./pages/unauthenticated/contato/contato.vue').default,
                meta: {
                    forVisitors: true,
                    forAuth: false,
                }
            },
        ]
    },
    /**
     * Páginas autenticadas
     */
    {
        path: '/dashboard',
        component: require('./layouts/dashboard/dashboard.vue').default,
        children: [
            {
                /**
                 * Tela do painel administrativo
                 */
                path: '/painel-administrativo',
                component: require('./pages/authenticated/dashboard/dashboard.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**Tela do sindicato */
                path: '/sistema/sindicatos/lista-sindicatos',
                component: require('./pages/authenticated/sindicatos/listar-sindicatos.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                 /**Tela do sindicato */
                 path: '/sistema/sindicatos/novo-sindicato',
                 component: require('./pages/authenticated/sindicatos/novo-sindicato.vue').default,
                 meta: {
                     forAuth: true,
                 },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                 /**Tela do sindicato */
                 path: '/sistema/sindicatos/editar-sindicato/:id',
                 component: require('./pages/authenticated/sindicatos/editar-sindicato.vue').default,
                 meta: {
                     forAuth: true,
                 },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**
                 * Tela do Nova Noticia
                 */
                path: '/sistema/noticias/nova-noticia',
                component: require('./pages/authenticated/noticias/nova-noticia.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**
                 * Tela do Listar Notícias
                 */
                path: '/sistema/noticias/lista-noticias',
                component: require('./pages/authenticated/noticias/listar-noticias.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**
                 * Tela do editar Notícias
                 */
                path: '/sistema/noticias/editar-noticias/:id',
                component: require('./pages/authenticated/noticias/editar-noticia.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**Tela do novo evento */
                path: '/sistema/eventos/novo-evento',
                component: require('./pages/authenticated/eventos/novo-evento.vue').default,
                meta: {
                    forAuth: true
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**Tela de editar evento */
                path: '/sistema/eventos/editar-evento/:id',
                component: require('./pages/authenticated/eventos/editar-evento.vue').default,
                meta: {
                    forAuth: true
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**Tela para listar eventos */
                path: '/sistema/eventos/lista-eventos',
                component: require('./pages/authenticated/eventos/listar-eventos.vue').default,
                meta: {
                    forAuth: true,
                },
            },
            /**Tela para adicionar participante */
            {
                path: '/sistema/evento/:id/novo-participante',
                component: require('./pages/authenticated/eventos/novo-participante.vue').default,
                meta: {
                    forAuth: true,
                },
            },
            /**Tela para editar participante */
            {
                path: '/sistema/eventos/:id/editar-participante/:participante_id',
                component: require('./pages/authenticated/eventos/editar-participante.vue').default,
                meta: {
                    forAuth: true,
                },
            },
            /**Tela para listar participantes */
            {
                path: '/sistema/evento/:id/lista-participantes',
                component: require('./pages/authenticated/eventos/listar-participantes-evento.vue').default,
                meta: {
                    forAuth: true,
                },
            },
            /**Tela para listar Contatos */
            {
                path: '/sistema/eventos/lista-contatos',
                component: require('./pages/authenticated/eventos/lista-contatos.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            /**Tela para Visualizar Contato */
            {
                path: '/sistema/eventos/visualizar-contato/:id',
                component: require('./pages/authenticated/eventos/visualizar-contato.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**
                 * Tela para adicionar publicações
                 */
                path: '/sistema/publicacoes/nova-publicacao',
                component: require('./pages/authenticated/publicacoes/nova-publicacao').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**
                 * Tela para listar publicações
                 */
                path: '/sistema/publicacoes/lista-publicacoes',
                component: require('./pages/authenticated/publicacoes/listar-publicacoes').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**
                 * Tela do Adicionar Vídeos
                 */
                path: '/sistema/videos/novo-video',
                component: require('./pages/authenticated/videos/novo-video.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**Tela para Listar vídeos */
                path: '/sistema/videos/lista-videos',
                component: require('./pages/authenticated/videos/listar-videos.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**Tela para Editar vídeos */
                path: '/sistema/videos/editar-video/:id',
                component: require('./pages/authenticated/videos/editar-video.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**Tela para Listar Newsletter (E-mails) */
                path: '/sistema/newsletter/lista-newsletter',
                component: require('./pages/authenticated/newsletter/listar-newsletter.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /**Tela de inadiplentes */
                path: '/sistema/financeiro/inadimplentes',
                component: require('./pages/authenticated/financeiro/Inadimplentes.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /** */
                path: '/sistema/boletos/configuracoes-boleto',
                component: require('./pages/authenticated/boletos/configurar/configuracoes-boleto.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /** */
                path: '/sistema/boletos/nova-configuracoes-boleto',
                component: require('./pages/authenticated/boletos/configurar/nova-configuracao-boleto.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /** */
                path: '/sistema/boletos/incluir-boleto',
                component: require('./pages/authenticated/boletos/operacoes/incluir-boleto.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
            {
                /** */
                path: '/sistema/boletos/lista-boletos',
                component: require('./pages/authenticated/boletos/operacoes/listar-boletos.vue').default,
                meta: {
                    forAuth: true,
                },
                beforeEnter: (to, from, next) => {
                    if (Vue.guard('tipo', '1')) {
                        next()
                    } else {
                        next('/sistema/eventos/lista-eventos')
                    }
                }
            },
        ]
    },
    /**
     * Páginas de erro
     */
    {
        /**
         * tela de erro 500
         */
        path: '/erro-inesperado',
        component: require('./pages/errors/500/server-error.vue').default,
    },
    {
        /**
         * Tela de erro 404
         */
        path: '*',
        component: require('./pages/errors/404/not-found.vue').default,
    }
]
